import React, { Component } from 'react';

import Textarea from 'react-textarea-autosize';

import slugify from 'slugify';

const Field = ({ value, onChange }) => {
  return 'Field';
};

export const FormGroup = ({
  type = 'text',
  name,
  value,
  onChange,
  helpText,
  placeholder,
  size,
}) => {
  const id = slugify(name);

  return (
    <div className="form-group row">
      <label
        htmlFor={name}
        className={'col-sm-2 ' + `col-form-label${size ? `-${size}` : ''}`}
      >
        {name}
      </label>
      <div className="col-sm-10">
        {type === 'textarea' ? (
          <Textarea
            id={id}
            className={
              'form-control ' + `${size ? `form-control-${size}` : ''}`
            }
            aria-describedby={`${id}Help`}
            placeholder={placeholder}
            value={value || ''}
            onChange={onChange}
          />
        ) : (
          <input
            type={type}
            id={id}
            className={
              'form-control ' + `${size ? `form-control-${size}` : ''}`
            }
            aria-describedby={`${id}Help`}
            placeholder={placeholder}
            value={value || ''}
            onChange={onChange}
          />
        )}
      </div>
      {helpText && (
        <small id={`${id}Help`} className="form-text text-muted">
          {helpText}
        </small>
      )}
    </div>
  );
};

const singularize = word => word.replace(/s$/, '');
export class MultiFormGroup extends Component {
  render() {
    const { name, values, onChange, renderField, newValue } = this.props;
    return (
      <div className="card">
        <h5 className="card-header">{name}</h5>
        <div className="card-body">
          <div className="form-group row">
            <label htmlFor={name} className={'col-sm-2 col-form-label'}>
              {/* {name} */}
            </label>

            <div className="col-sm-10">
              {(values || []).map((v, i) => {
                const field = renderField({
                  value: v,
                  onChange: newValue => {
                    onChange(values.map((v, j) => (j === i ? newValue : v)));
                  },
                  onDelete: () => {
                    onChange(values.filter((v, j) => j !== i));
                  },
                });
                return <div key={i}>{field}</div>;
              })}

              <button
                className="btn btn-link"
                onClick={e => {
                  e.preventDefault();
                  onChange([...(values || []), newValue()]);
                }}
              >
                New {singularize(name)}...
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Forms.js